import { render, staticRenderFns } from "./PageModeratorClassroomAdd.vue?vue&type=template&id=0c1d2922&"
import script from "./PageModeratorClassroomAdd.vue?vue&type=script&lang=js&"
export * from "./PageModeratorClassroomAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
